import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/rustomjee-logo.webp"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        With a legacy of over two decades, Rustomjee has reshaped Mumbai’s
        skyline through iconic residential and commercial developments. Known
        for pioneering thoughtful design, Rustomjee has delivered 14 million+
        sq. ft., with 2 million+ sq. ft. currently under development. Their core
        ethos lies in redefining what ‘living well’ means—through architectural
        excellence, attention to detail, and unmatched location choices.
        <br />
        Rustomjee Crescent stands as a true embodiment of the brand’s enduring
        legacy—where architecture, location, and lifestyle converge to create a
        rare living experience. Set in the heart of Bandra’s iconic Pali Hill,
        this boutique development is designed for the city's most discerning
        residents who value understated luxury and thoughtful design. Every
        element, from sea-facing decks to limited apartments per floor, speaks
        of exclusivity and elegance. It’s not just a home—it’s a refined address
        that mirrors a life well-earned.
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51800080217.PNG" alt="rera qr" />
          <strong>P51800080217</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
